import { library } from "@fortawesome/fontawesome-svg-core";
import { faBriefcase } from "@fortawesome/pro-regular-svg-icons";
import { useEffect } from "react";

export function useIcons() {
  useEffect(() => {
    library.add(faBriefcase);
  }, []);
}
